import { createApp, ref, onMounted, watch, nextTick } from 'vue';
import { createPinia, storeToRefs } from 'pinia';
import layout from '@/style/layout.scss';
import $ from 'jquery';
import validate from '@global/vendors/jquery.validate.min';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useModalStore from '@global/stores/useModalStore';

import useAlert from '@global/composable/useAlert';
import useMsg from '@global/composable/useMessage';
import useTextProcessing from '@global/composable/useTextProcessing';

import NewImage from '@global/components/common/Image/NewImage.vue';
import AlertDialog from '@global/components/common/alert/AlertDialog.vue';
import Message from '@global/components/common/message/Message.vue';
import Modal from '@global/components/common/modal/Modal.vue';

import modal from 'bootstrap/js/dist/modal';
import collapse from 'bootstrap/js/dist/collapse';

import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';

const pinia = createPinia();
const { alertDialog } = useAlert();
const { messageBox } = useMsg();
const { useAutoSupplement } = useTextProcessing();

window.nowBrand = {};

global.$ = require('jquery');

global.jQuery = global.$;

/**
 * alert跳窗
 */
// eslint-disable-next-line vue/one-component-per-file
const appAlert = createApp({
  components: {
    AlertDialog,
    Message,
  },
});

appAlert.mount('#app-common');

/**
 * Header選單
 */

// eslint-disable-next-line vue/one-component-per-file
const appHeader = createApp({
  components: {
    NewImage,
    Modal,
  },
  setup() {
    const miniCartStore = useMiniCartStore();
    const modalStore = useModalStore();

    const { modalName } = storeToRefs(modalStore);

    const {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      dataIsLoad,
      generalMarketProducts,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,
    } = storeToRefs(miniCartStore);

    const { getCartInfo, getHotSearch } = miniCartStore;
    getCartInfo();
    getHotSearch();

    function lockBody(open) {
      if (open) {
        $('body').addClass('lock-page');
      } else {
        $('body').removeClass('lock-page');
      }
    }

    // miniCart 購物車
    const isCartVisible = ref(false);
    const cartMaskRef = ref(null);
    const cartMaskStyle = ref(null);
    function openCartPanel() {
      isCartVisible.value = true;
      cartMaskStyle.value = {
        right: '290px',
        zIndex: '1030',
      };
      lockBody(isCartVisible.value);
    }
    function closeCartPanel() {
      isCartVisible.value = false;
      lockBody(isCartVisible.value);
    }

    // hamburger 漢堡選單
    const isSidebarVisible = ref(false);
    const burgerMaskRef = ref(null);
    const burgerMaskStyle = ref(null);
    function openSidebar() {
      isSidebarVisible.value = true;

      burgerMaskStyle.value = {
        zIndex: '1030',
      };
      lockBody(isSidebarVisible.value);
    }
    function closeSidebar() {
      isSidebarVisible.value = false;
      lockBody(isSidebarVisible.value);
    }

    // search 搜尋展開
    const isSearchVisible = ref(false);
    const searchInputPcRef = ref(null);
    const searchInputMbRef = ref(null);
    const searchText = ref('');
    function openSearch() {
      isSearchVisible.value = true;
      nextTick(() => {
        if (searchInputPcRef.value) {
          searchInputPcRef.value.focus();
        }
        if (searchInputMbRef.value) {
          searchInputMbRef.value.focus();
        }
      });
    }
    function closeSearch() {
      isSearchVisible.value = false;
    }
    function goSearchText() {
      if (searchText.value.trim() === '') {
        alertDialog.alert('請輸入關鍵字');
      } else {
        window.location.href = `/search?Keyword=${searchText.value}`;
        fireSearchEvent({
          isHotSearch: false,
          keyword: searchText.value,
        });
      }
    }

    function goSearch(item) {
      window.location.href = `/search?Keyword=${item}`;
      fireSearchEvent({
        isHotSearch: true,
        keyword: item,
      });
    }

    // 手機板確認
    const isMobile = ref(false);
    function windowSize() {
      if ($(window).width() < 992) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
    }

    // GTM
    watch(hotLoad, (nV, oV) => {
      if (nV && window.location.pathname.includes('search')) {
        fireSearchListEvent(hotSearch.value);
      }
    });

    onMounted(() => {
      // 手機板確認
      windowSize();
      $(window).resize(() => {
        windowSize();
      });
    });

    return {
      isMobile,
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      dataIsLoad,
      generalMarketProducts,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,
      useAutoSupplement,
      searchInputPcRef,
      searchInputMbRef,
      searchText,
      isCartVisible,
      cartMaskRef,
      cartMaskStyle,
      isSidebarVisible,
      burgerMaskRef,
      burgerMaskStyle,
      isSearchVisible,
      modalName,
      openSearch,
      closeSearch,
      goSearchText,
      goSearch,
      openCartPanel,
      closeCartPanel,
      openSidebar,
      closeSidebar,
    };
  },
});

appHeader.use(pinia).mount('#app-mini-cart');

// fix when mutiple inputs with same name always validate the first item.
// eslint-disable-next-line func-names
$.validator.prototype.checkForm = function () {
  // overriden in a specific page
  this.prepareForm();
  // eslint-disable-next-line no-multi-assign
  for (let i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++) {
    if (
      this.findByName(elements[i].name).length !== undefined &&
      this.findByName(elements[i].name).length > 1
    ) {
      for (let cnt = 0; cnt < this.findByName(elements[i].name).length; cnt++) {
        this.check(this.findByName(elements[i].name)[cnt]);
      }
    } else {
      this.check(elements[i]);
    }
  }
  return this.valid();
};

// 全域方法前後端使用
window.messageBox = messageBox;
window.AlertDialog = alertDialog;
